cartIncrementor = {
  els: {
    $page: jQuery('html'),
    $cartItems: document.querySelectorAll('tr[data-cart-item-variant-id]')
  },
  init: function () {
    var self = this;

    this.els.$cart = this.els.$page.find('[data-cart]');
    this.els.$cartCountHeader = this.els.$page.find('[data-header-cart-count]');
    this.els.$cartCountSidebar = this.els.$cart.find('[data-cart-sidebar-count]');
    this.els.$cartSubtotal = this.els.$cart.find('[data-cart-subtotal]');
    this.els.$incrementor = this.els.$cart.find('[data-cart-increment]');
    this.els.$minicartPromo = this.els.$page.find('[data-promo="minicart"]');
    this.els.$promoDiff = this.els.$page.find('[data-promo-difference]');
    this.els.$shippingCost = this.els.$cart.find('[data-cart-sidebar-shipping]');
    this.els.$shippingPromoActive = this.els.$cart.find('[data-shipping-promo="active"]');
    this.els.$shippingPromoComplete = this.els.$cart.find('[data-shipping-promo="complete"]');

    this.currency = (typeof miniCart !== 'undefined') ? miniCart.currency : 'USD';
    this.locale = (typeof miniCart !== 'undefined') ? miniCart.locale : 'en-US';

    this.formatter = new Intl.NumberFormat(self.locale, {
      style: 'currency',
      currency: self.currency,
      minimumFractionDigits: 2
    });

    this.els.$cart.on('click', '[data-cart-increment]', function() {
      self.quantityIncrementor(jQuery(this))
    });
  },

  quantityIncrementor: function($el) {
    var self = this,
        $currentIncrementor = $el.closest('[data-cart-incrementor]'),
        $currentNumberInput = $currentIncrementor.find('input[type="number"]'),
        cartSubtotal,
        amount = {},
        item = {};

    item.$row = $currentIncrementor.closest('tr[data-cart-item-variant-id]');
    item.variantId = item.$row.data('cart-item-variant-id');
    item.$remove = item.$row.find('[data-cart-item-remove]')
    item.$total = item.$row.find('[data-cart-item-total]')
    item.price = parseFloat(item.$row.data('item-price'));
    item.zeroIndex = item.$row.index();
    item.oneIndex = item.zeroIndex + 1;

    amount.change = parseFloat($el.data('cart-increment'));
    amount.current = parseFloat($currentNumberInput.val());
    amount.min = parseFloat($currentNumberInput.attr('min'));
    amount.new =  Math.max((amount.current + amount.change), amount.min);

    if (amount.current + amount.change < amount.min) return // cant go below min

    item.$minicartItem = this.els.$page.find('[data-minicart-item-variant-id="' + item.variantId + '"]');
    item.$minicartItemTotal = item.$minicartItem.find('[data-minicart-item-count]');
    item.$minicartSubtotal = this.els.$page.find('[data-minicart-subtotal]');
    item.total = item.price * amount.new;

    // updating item in cart
    jQuery.post('/cart/change.js', {
      line: item.oneIndex, quantity: amount.new
    }).always(function() {
      if ($currentIncrementor.data('force-reload')) {
        window.location.reload();
      }
      self.els.$cart.trigger('cart:update');
    });

    // update value of input
    $currentNumberInput.val(amount.new);

    // update item total
    item.$total.text(slate.Currency.formatMoney(item.total, theme.moneyFormat));
    item.$row.attr('data-item-total', item.total);

    // update the item count in minicart
    item.$minicartItemTotal.text(amount.new);

    // update cart count in header
    this.els.cartCountHeaderAmount = parseFloat(this.els.$cartCountHeader.text());
    const newTotal = this.els.cartCountHeaderAmount += amount.change

    this.els.$cartCountHeader.text(newTotal)

    // update cart count in sidebar
    this.els.$cartCountSidebar.text(newTotal)

    // update cart subtotal
    cartSubtotal = 0;

    this.els.$cartItems.forEach((el, i) => {
      cartSubtotal += parseFloat(el.dataset.itemTotal);
    });

    const subtotal = slate.Currency.formatMoney(cartSubtotal, theme.moneyFormat)

    this.els.$cartSubtotal.text(subtotal);

    // update cart subtotal
    item.$minicartSubtotal.text(subtotal);

    const freeShippingAmount = (typeof freeShipping !== 'undefined') ? parseFloat(freeShipping.amount) : 0;

    // Handle shipping promo
    if (freeShippingAmount > 0 && cartSubtotal < freeShippingAmount) {
      const difference = freeShippingAmount - cartSubtotal;
      this.els.$shippingCost.text('TBD');
      this.els.$shippingPromoComplete.addClass('hidden');
      this.els.$shippingPromoActive.removeClass('hidden');
      this.els.$minicartPromo.removeClass('hidden');
      this.els.$promoDiff.text(self.formatter.format(difference / 100));
    } else {
      this.els.$shippingCost.text('FREE');
      this.els.$shippingPromoActive.addClass('hidden');
      this.els.$shippingPromoComplete.removeClass('hidden');
      this.els.$minicartPromo.addClass('hidden');
    }

    // remove item if its going to zero
    if (amount.new === 0) {
      item.$remove[0].click();
    }
  },
}

jQuery(function () {
  cartIncrementor.init();
});
